import React from 'react';
import ReactDOM from 'react-dom';

import App from './pages/index.js';
import data from './data/data.js';
import twitterData from './data/twitterData.js';
import template from './data/template.js';

require('./ads.js');

const render = () => {
	ReactDOM.render(
    <App data={data} twitterData={twitterData} template={template} />,
    document.getElementById('root')
  );
};

render();



// WEBPACK FOOTER //
// ./theroot/root-100-2019/src/client.js